





































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import Apis from '@/Apis/_'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'
import { CirurgiaConjunta, MedicoElegivelCirurgiaConjunta } from '@/types/interfaces/CirurgiaConjunta'

@Component
export default class CirurgiaConjuntaComponent extends Vue {
  @Prop({ default: false }) disabled: boolean

  searchText: string = ''

  medicosEncontrados: MedicoElegivelCirurgiaConjunta[] = []

  loadingBusca: boolean = false

  pagina: number = 1

  qtdPorPagina: number = 10

  totalMedicos: number = 0

  medicoParaVincular: MedicoElegivelCirurgiaConjunta | null = null

  showModalVincular: boolean = false

  debounceSearch = _.debounce(() => this.buscarMedicosElegiveis(), 700)

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get solicitacaoCirurgia() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia
  }

  // Campos configuráveis por hospital em Configurações > Solicitação de cirurgia
  // (stepper.vue, seção Cirurgia conjunta). tipoConselho não entra aqui porque o
  // endpoint de médicos elegíveis não devolve esse dado — nada pra mostrar mesmo
  // com o campo habilitado.
  get camposCirurgiaConjunta() {
    const { formulario } = this.getSolicitacaoCirurgiaStore.template
    return (formulario && formulario.cirurgiaConjunta && formulario.cirurgiaConjunta.campos) || {}
  }

  get mostrarNomeMedico() {
    return !!(this.camposCirurgiaConjunta.nomeMedico && this.camposCirurgiaConjunta.nomeMedico.habilitado)
  }

  get mostrarNumeroConselho() {
    return !!(this.camposCirurgiaConjunta.numeroConselho && this.camposCirurgiaConjunta.numeroConselho.habilitado)
  }

  get mostrarUf() {
    return !!(this.camposCirurgiaConjunta.uf && this.camposCirurgiaConjunta.uf.habilitado)
  }

  get mostrarEspecialidade() {
    return !!(this.camposCirurgiaConjunta.especialidade && this.camposCirurgiaConjunta.especialidade.habilitado)
  }

  get mostrarEmail() {
    return !!(this.camposCirurgiaConjunta.email && this.camposCirurgiaConjunta.email.habilitado)
  }

  get tableHeaders() {
    return [
      ...(this.mostrarNomeMedico ? [{ text: 'Nome do médico', value: 'medicoNome' }] : []),
      ...(this.mostrarNumeroConselho ? [{ text: 'Número conselho', value: 'numeroConselho' }] : []),
      ...(this.mostrarUf ? [{ text: 'UF', value: 'uf' }] : []),
      ...(this.mostrarEspecialidade ? [{ text: 'Especialidade', value: 'especialidade' }] : []),
      ...(this.mostrarEmail ? [{ text: 'E-mail', value: 'email' }] : []),
      { text: '', value: 'acoes', sortable: false },
    ]
  }

  get tableHeadersAdicionados() {
    return [
      ...(this.mostrarNomeMedico ? [{ text: 'Nome do médico', value: 'medicoNome' }] : []),
      ...(this.mostrarNumeroConselho ? [{ text: 'Número conselho', value: 'conselhoNumero' }] : []),
      ...(this.mostrarUf ? [{ text: 'UF', value: 'uf' }] : []),
      ...(this.mostrarEspecialidade ? [{ text: 'Especialidade', value: 'especialidade' }] : []),
      ...(this.mostrarEmail ? [{ text: 'E-mail', value: 'email' }] : []),
      { text: '', value: 'acoes', sortable: false },
    ]
  }

  get medicosAdicionados(): CirurgiaConjunta[] {
    return this.solicitacaoCirurgia.cirurgiasConjuntas || []
  }

  set medicosAdicionados(medicos: CirurgiaConjunta[]) {
    this.solicitacaoCirurgia.cirurgiasConjuntas = medicos
  }

  get totalPaginas() {
    return Math.ceil(this.totalMedicos / this.qtdPorPagina)
  }

  // Médico já adicionado some da busca — ele já aparece na seção "Médicos adicionados".
  get medicosEncontradosVisiveis() {
    return this.medicosEncontrados.filter(medico => !this.jaAdicionado(medico))
  }

  jaAdicionado(medico: MedicoElegivelCirurgiaConjunta) {
    return this.medicosAdicionados.some(item => item.medicoId === medico.medicoId)
  }

  mounted() {
    this.buscarMedicosElegiveis()
  }

  onFocusBusca() {
    if (!this.medicosEncontrados.length) {
      this.buscarMedicosElegiveis()
    }
  }

  onSearchInput(value: string | null) {
    // O botão de limpar (clearable) do Vuetify manda null, não ''.
    this.searchText = value || ''
    this.pagina = 1

    if (!this.searchText) {
      this.buscarMedicosElegiveis()
      return
    }

    if (this.searchText.length > 2) {
      this.debounceSearch()
    }
  }

  async buscarMedicosElegiveis() {
    this.loadingBusca = true

    const response = await Apis.Agendamento.CirurgiaConjuntaApi.getMedicosElegiveis({
      HospitalId: this.solicitacaoCirurgia.hospitalId,
      PacienteId: this.solicitacaoCirurgia.paciente.id || undefined,
      MedicoId: this.solicitacaoCirurgia.medicoSolicitanteId,
      SearchText: this.searchText,
      Pagina: this.pagina,
      QtdPorPagina: this.qtdPorPagina,
    })

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao buscar médicos elegíveis.', 'error'))
      this.loadingBusca = false
      return
    }

    this.medicosEncontrados = response.data || []
    this.totalMedicos = response.total || 0
    this.loadingBusca = false

    // Página inteira já adicionada — avança sozinho até achar alguém pra mostrar
    // (ou acabar as páginas), pra não deixar a busca parecendo vazia à toa.
    if (!this.medicosEncontradosVisiveis.length && this.medicosEncontrados.length && this.pagina < this.totalPaginas) {
      this.pagina += 1
      await this.buscarMedicosElegiveis()
    }
  }

  temSolicitacoes(medico: MedicoElegivelCirurgiaConjunta) {
    return !!(medico.solicitacoes && medico.solicitacoes.length)
  }

  abrirModalVincular(medico: MedicoElegivelCirurgiaConjunta) {
    this.medicoParaVincular = medico
    this.showModalVincular = true
  }

  confirmarVinculo(solicitacaoId: string | null) {
    if (this.medicoParaVincular) {
      this.adicionarMedico(this.medicoParaVincular, solicitacaoId)
    }

    this.showModalVincular = false
  }

  adicionarMedico(medico: MedicoElegivelCirurgiaConjunta, solicitacaoId: string | null = null) {
    if (this.jaAdicionado(medico)) {
      return
    }

    this.medicosAdicionados = [
      ...this.medicosAdicionados,
      {
        medicoId: medico.medicoId,
        medicoNome: medico.medicoNome,
        solicitacaoId: solicitacaoId || undefined,
        conselhoNumero: medico.numeroConselho,
        especialidade: medico.especialidade,
        uf: medico.uf,
        email: medico.email,
      },
    ]
  }

  removerMedico(medico: { medicoId: string }) {
    this.medicosAdicionados = this.medicosAdicionados.filter(item => item.medicoId !== medico.medicoId)
  }
}
